import '../../utils/index.mjs';
import _sfc_main from './src/link2.mjs';
export { linkEmits, linkProps } from './src/link.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElLink = withInstall(_sfc_main);

export { ElLink, ElLink as default };
//# sourceMappingURL=index.mjs.map
